import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const FiatWithdrawal = () => {
  const [formData, setFormData] = useState({
    orderId: "",
    currency: "AED",
    amount: "",
    date: "",
    info: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Submitted:", formData);
  };

  return (
<div className="bg-white dark:bg-gray-900 text-gray-900 dark:text-white transition-colors duration-300">
    <Header />
        <div className="max-w-3xl mx-auto p-8 rounded-md shadow-sm">
      <form onSubmit={handleSubmit} className="space-y-6">
        {/* Section 1 */}
        <h3 className="text-lg font-semibold flex items-center gap-2">
          <span className="w-6 h-6 flex items-center justify-center rounded-full border border-gray-400 text-sm font-medium">
            1
          </span>
          Basic Information <span className="text-red-500">*</span>
        </h3>

        {/* Order ID */}
        <div>
          <label className="block text-sm font-medium mb-1">Order ID</label>
          <input
            type="text"
            name="orderId"
            value={formData.orderId}
            onChange={handleChange}
            placeholder="Please enter your order ID"
            className="w-full border border-gray-300 rounded-md p-2 text-sm focus:ring focus:ring-yellow-300 bg-transparent outline-none"
          />
        </div>

        {/* Currency */}
        <div>
          <label className="block text-sm font-medium mb-1">Currency</label>
          <select
            name="currency"
            value={formData.currency}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded-md p-2 text-sm bg-transparent"
          >
            <option value="AED">AED</option>
            <option value="USD">USD</option>
            <option value="INR">INR</option>
          </select>
        </div>

        {/* Amount */}
        <div>
          <label className="block text-sm font-medium mb-1">Amount</label>
          <input
            type="number"
            name="amount"
            value={formData.amount}
            onChange={handleChange}
            placeholder="Please enter exact amount you have transferred"
            className="w-full border border-gray-300 rounded-md p-2 text-sm focus:ring focus:ring-yellow-300 bg-transparent outline-none"
          />
        </div>

        {/* Date */}
        <div>
          <label className="block text-sm font-medium mb-1">Transaction Date</label>
          <input
            type="date"
            name="date"
            value={formData.date}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded-md p-2 text-sm bg-transparent"
          />
          <p className="text-xs text-gray-500 mt-1">
            Select the date you initiated the transfer
          </p>
        </div>

        {/* Section 2 */}
        <h3 className="text-lg font-semibold flex items-center gap-2">
          <span className="w-6 h-6 flex items-center justify-center rounded-full border border-gray-400 text-sm font-medium">
            2
          </span>
          Additional Information <span className="text-red-500">*</span>
        </h3>

        {/* Textarea */}
        <div>
          <textarea
            name="info"
            rows="5"
            maxLength="500"
            value={formData.info}
            onChange={handleChange}
            placeholder="Describe the reason for your appeal"
            className="w-full border border-gray-300 rounded-md p-2 text-sm focus:ring focus:ring-yellow-300 bg-transparent outline-none"
          />
          <div className="text-right text-xs text-gray-500">
            {formData.info.length}/500
          </div>
        </div>

        {/* Buttons */}
        <div className="flex justify-end space-x-3">
          <button
            type="button"
            className="px-6 py-2 border border-gray-300 rounded-md bg-gray-100 text-gray-700 hover:bg-gray-200"
          >
            Cancel
          </button>
          <button
            type="submit"
            className="px-6 py-2 rounded-md bg-yellow-400 text-black font-medium hover:bg-yellow-500"
          >
            Submit
          </button>
        </div>
      </form>
    </div>
    <Footer />
</div>
  );
};

export default FiatWithdrawal;
